module.exports = __webpack_public_path__ + "static/Ecosystem-icon-20-b281a5a68803a7f79af13bf9990f947a.png";